var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJug({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.087 55v18h110V55h-110zm18.916 36c13.267 48.186 13.05 107.504-20.51 156.113l-.232.336-.26.312c-38.645 46.375-45.757 87.258-41.964 123.297 3.5 33.254 16.698 61.922 25.33 85.94h147.44c8.632-24.018 21.83-52.686 25.33-85.94 3.793-36.04-3.317-76.923-41.963-123.298l-.308-.37-.266-.4C268.13 199.788 266.15 139.572 279.23 91H207zm90.428.953a194.65 194.65 0 0 0-4.163 17.48c20.632 4.508 34.043 12.905 42.808 23.31 10.8 12.822 15.037 29.498 14.78 48.196-.354 25.68-9.735 54.496-20.463 77.36 4.116 6.255 7.75 12.46 10.935 18.6 13.874-25.895 27.054-61.406 27.526-95.712.297-21.615-4.74-43.095-19.012-60.04-11.544-13.706-28.812-23.915-52.41-29.195z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJug);
export default __webpack_public_path__ + "static/media/jug.6c3be87a5a133de6673c896982f07c45.svg";
export { ForwardRef as ReactComponent };